import Image from 'next/image';
import Link from 'next/image';
import style from './social_media.module.css';

export default function SocialMedia() {
  return (
    <ul className={style.social_media_wrapper}>
      <li>
        <Image src="/assets/icon-svg/social-fb-outline.svg" width={32} height={32} />
      </li>
      <li>
        <Image src="/assets/icon-svg/social-tw-outline.svg" width={32} height={32} />
      </li>
      <li>
        <Image src="/assets/icon-svg/social-line-outline.svg" width={32} height={32} />
      </li>
      <li>
        <Image src="/assets/icon-svg/social-yt-outline.svg" width={32} height={32} />
      </li>
    </ul>
  );
}
